/**
 * Created by Mattias on 2014-09-24.
 */
define('payment/externalPanel',['jquery', 'boxes/helpers/box-loading', 'boxes/helpers/payment-sender-helper'], function ($, boxLoading, paymentSenderHelper) {
    'use strict';

    var methodFunction = {
            post: post,
            get: get
        },
        IFRAME_NAME = 'iframepopup-iframeid';


    function post(paymentBox, externalPanelInformation) {
        window.top.dialog.flow(
            externalPanelInformation.openExternalPanelFlow, {
                headerTextKey: externalPanelInformation.headerTextKey,
                GSON_PARAMETER: externalPanelInformation.pageGsonParameter
            },
            function () {
                postToIframe(externalPanelInformation.externalParameters, externalPanelInformation.externalUrl, IFRAME_NAME);
            },
            function () {
                closeDialogHandler(paymentBox);
            }
        );

        function postToIframe(data, url, target) {
            var $form = $('<form>').attr({
                action: url,
                method: 'POST',
                target: target,
                id: 'postToIframe'
            });
            $.each(data, function (name, value) {
                if (name === 'method') {
                    return;
                }
                var $input = $('<input>').attr({
                    type: 'hidden',
                    name: name,
                    value: value
                });
                $form.append($input);
            });
            $(document.body).append($form);
            $form.submit().remove();
        }
    }

    function get(paymentBox, externalPanelInformation) {
        var urlWithParameters = paymentSenderHelper.createUrlWithParameters(externalPanelInformation.externalUrl, externalPanelInformation.externalParameters);
        window.top.dialog.flow(
            externalPanelInformation.openExternalPanelFlow,
            {
                headerTextKey: externalPanelInformation.headerTextKey,
                GSON_PARAMETER: externalPanelInformation.pageGsonParameter
            },
            function () {
                $('#' + IFRAME_NAME, parent.document.body).attr('src', urlWithParameters);
            },
            function () {
                closeDialogHandler(paymentBox);
            }
        );
    }

    function closeDialogHandler(paymentBox) {
        paymentBox.$box.find('.deposit-button').prop('disabled', false);
		paymentBox.$box.find('.withdraw-button').prop('disabled', false);
        boxLoading.removeLoading(paymentBox.$box);
    }

    function openExternalPanel(paymentBox, externalPanelInformation) {
        var defaultExternalParameters = {
                method: 'get'
            },
            externalParameters = $.extend(defaultExternalParameters, externalPanelInformation.externalParameters);

        methodFunction[externalParameters.method](paymentBox, externalPanelInformation);
    }

    var externalpanel = {};
    externalpanel.openExternalPanel = openExternalPanel;
    window.top.externalpanel = externalpanel;
    return externalpanel;
});

